import '../se-heading/se-heading';
import '../se-social-link/se-social-link';
import '../se-button/se-button';
import '../se-container/se-container';
import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import componentStyles from './se-capability-hero.css.lit';
import { SlotController } from '../../controllers/slot-controller';

/**
 * The Capability Hero component.
 * @element capability-hero
 *
 * @slot default - background image.
 */
@customElement('capability-hero')
export class CapabilityHero extends OutlineElement {
  slots = new SlotController(this, true);
  static styles: CSSResultGroup = [componentStyles];

  /**
   * Capability Hero required attributes
   */

  @property({ type: String, attribute: 'header' })
  header: string;
  @property({ type: String, attribute: 'description' })
  description: string;
  @property({ type: String, attribute: 'link-text' })
  linkText: string;
  @property({ type: String, attribute: 'link-url' })
  linkURL: string;

  bgTemplate(): TemplateResult {
    return html`
      <div class="background-image">
        <slot name="background-image"></slot>
      </div>
    `;
  }

  cardTemplate(): TemplateResult {
    return html`
      <section class="capability-card">
        ${this.header
          ? html`<se-heading level="h1" class="capability-name"
              >${this.header}</se-heading
            >`
          : null}
        ${this.description
          ? html`<div class="description">${this.description}</div>`
          : null}
        ${this.linkURL
          ? html` <se-button
              class="cta"
              variant="primary"
              size="medium"
              button-url="${this.linkURL}"
              button-label="${this.linkText}"
            >
              ${this.linkText}
              <outline-icon
                color="brand-secondary-2"
                slot="right"
                library="system"
                name="arrow-right"
                size="1em"
              ></outline-icon>
            </se-button>`
          : null}
      </section>
    `;
  }

  render(): TemplateResult {
    return html`
      <section class="capability-hero">
        ${this.bgTemplate()}
        <se-container justify-end>
          <div class="card-wrapper">${this.cardTemplate()}</div>
        </se-container>
      </section>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'capability-hero': CapabilityHero;
  }
}
